/** Align with backend `marketingAnalyticsConsentPolicyVersion` (plan D6). */
export const CONSENT_VERSION = 'v1' as const;

/**
 * Align with backend `LEGAL_CONSENT_VERSION` (`legalConsent.ts`) — engineering
 * fallback / bootstrap published constant until LegalDocument CMS publishes.
 */
export const LEGAL_CONSENT_VERSION = 'v1' as const;

/**
 * Dual TERMS/PRIVACY versions (G10). Until the public meta endpoint is consumed
 * at runtime, both purposes stay aligned with `LEGAL_CONSENT_VERSION`.
 * Callers that need live published versions should prefer meta from
 * `publicLegalDocumentUrl(..., { meta: true })` once the gateway is live.
 */
export type LegalConsentVersions = {
  readonly termsVersion: string;
  readonly privacyVersion: string;
};

export const FALLBACK_LEGAL_CONSENT_VERSIONS: LegalConsentVersions = {
  termsVersion: LEGAL_CONSENT_VERSION,
  privacyVersion: LEGAL_CONSENT_VERSION,
};
